module.exports = __webpack_public_path__ + "static/media/makemit2.763a4eec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/liberty/makemit2.jpg
// module id = 60
// module chunks = 0